export default __webpack_public_path__ + "337ea0c7dc7463bf72e4ac438a7c68bd.png";